const getDefaultValue = (component, variableName) => {
    var _a, _b;
    return (_b = (_a = component.findVariable(variableName)) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.default;
};
export class JourneyV3ComponentAdapter {
    constructor(component) {
        this.component = component;
    }
    getComponentId() {
        return this.component.id;
    }
    getCampaignId() {
        return this.component.campaign_id;
    }
    getDisplayName() {
        return this.component.getDisplayName();
    }
    getDescription() {
        return this.component.description;
    }
    getBuiltComponent() {
        return this.component;
    }
    getType() {
        return this.component.type;
    }
    getJourneyNames() {
        var _a;
        return (_a = getDefaultValue(this.component, "journeyNames")) !== null && _a !== void 0 ? _a : [];
    }
    getBusinessEventV2ComponentIds() {
        const businessEventSocket = this.component.findSocket("businessEvent");
        if (!businessEventSocket) {
            return [];
        }
        return businessEventSocket.getInstalledComponentIds();
    }
    getRuleSocket() {
        return this.component.findSocket("rule");
    }
    getSequence() {
        const variable = this.component.findVariable("sequence");
        const defaultValue = variable === null || variable === void 0 ? void 0 : variable.getValue("default");
        if (defaultValue) {
            return defaultValue;
        }
        return "100";
    }
    getColor() {
        return this.component.getColor();
    }
}
